import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.isAuthenticated()) {
    return true;
  }

  if (auth.status() === 'no-access') {
    return router.createUrlTree(['/unauthorized']);
  }

  if (auth.status() === 'error') {
    return router.createUrlTree(['/login']);
  }

  auth.login(state.url);
  return false;
};
